import { useEffect, useState } from 'react'

const useSize = (): UseSizeFunctionReturnTypes => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 860)

        checkMobile()
        window.addEventListener('resize', checkMobile)

        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    return { isMobile }
}

export default useSize
